'use client'

import { trackEvent } from '@/utils/tracking'
import { useEffect } from 'react'

/**
 * Zählt Klicks auf mailto-Links.
 *
 * Hintergrund: Anfragen kommen bei KOMMERS überwiegend per Mail, aber genau
 * dieser Pfad war der einzige ungemessene. Weder Google Ads noch GA4 sahen,
 * ob eine Landingpage eine Mailanfrage ausgelöst hat, während Formular und
 * Calendly längst getrackt werden (siehe utils/tracking.ts).
 *
 * Bewusst ein delegierter Listener auf document statt einer eigenen
 * Link-Komponente: die mailto-Links stehen über gut 20 Stellen verteilt,
 * größtenteils in Server-Komponenten. So greift das Tracking überall und auch
 * bei Links, die später dazukommen.
 *
 * Feuert absichtlich KEINE Ads-Conversion. Ein Mailklick ist ein Absichts-,
 * kein Abschlusssignal. In Google Ads gehört er als sekundäre Conversion-Action
 * importiert, sonst verwässert er die Optimierung auf echte Leads.
 */
export default function MailtoTracker() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target
      if (!(target instanceof Element)) return

      const link = target.closest('a[href^="mailto:"]')
      if (!link) return

      // Nur der Pfad, nie die Adresse: eine Mitarbeiteradresse in einem
      // Analytics-Event wäre personenbezogen.
      trackEvent('mailto_click', { source: window.location.pathname })
    }

    // capture: true, damit der Klick auch dann ankommt, wenn ein Handler
    // weiter unten die Propagation stoppt.
    document.addEventListener('click', handleClick, { capture: true })
    return () => document.removeEventListener('click', handleClick, { capture: true })
  }, [])

  return null
}
